import { JobListWidgetRenderer } from "../renderer/JobListWidgetRenderer"
import { JobListWidgetRequestDto } from "../dtos/JobListRequestDto";
import { InfiniteScrollHelper , ResponseCallback} from "../libs/infinite-scroll-helper";
import { IResponse, IResponseWithData, RequestType } from "../libs/request-helper";
import { JobOfferEntryDto } from '../dtos/JobOfferEntryDto';

declare var BASE_URL: any;
declare var API_VERSION: any;
export class JobListWidget implements ResponseCallback {
    protected static ERROR_MSG = "Es konnten leider keine Jobs gefunden werden!";
    protected static REQUEST_URL = "api/" + API_VERSION + "/PublicData/JobOffersBySearchQuery";
    protected jobsContainer: HTMLElement;
    protected mainContainer: HTMLElement;
    protected requestDto: JobListWidgetRequestDto;
    protected jobListWidgetRenderer: JobListWidgetRenderer;
    protected static firstInit = true;
    protected scrollHelper : InfiniteScrollHelper;
    protected listItemCount = 0;
    protected showFilter : Boolean = false;
    private checkboxFilterFullTime: HTMLInputElement;
    private checkboxFilterPartTime: HTMLInputElement;
    private checkboxFilterApprentice: HTMLInputElement;

    protected static async init(): Promise<void> {
        if(JobListWidget.firstInit){
            JobListWidget.firstInit = false;
            document.addEventListener('DOMContentLoaded', JobListWidget.onDocumentLoaded, false);
        }
    }

    constructor(private target: HTMLElement, private id: String) {
        const attr = JSON.parse(this.target.getAttribute("data-joblist-attr"));
        const scrollable = this.target.getAttribute("data-container-scrollable");
        const showFilter = Boolean(this.target.getAttribute("data-showfilter"));
        if(attr == null) {
			return;
        }
        this.requestDto = attr;
        this.requestDto.pageNumber = 0;
        this.jobsContainer = <HTMLElement> this.target.getElementsByClassName("jobsContainer")[0];
        if(attr.lat) {
            this.requestDto.lat = Number(attr.lat);
        }
        if(attr.lon) {
            this.requestDto.lon = Number(attr.lon);
        }
        if(attr.radius) {
            this.requestDto.radius = Number(attr.radius);
        }
        if(attr.maxItems) {
            this.requestDto.maxItems = Number(attr.maxItems);
        } else {
            this.requestDto.maxItems = Infinity;
        }
        this.jobListWidgetRenderer = new JobListWidgetRenderer(this.jobsContainer, JobListWidget.ERROR_MSG);
        let scroll: any = window;
        if(scrollable) {
            scroll = this.jobsContainer
        }

        this.scrollHelper = new InfiniteScrollHelper(
            this.jobsContainer,
            this,
            this.requestDto,
            BASE_URL + JobListWidget.REQUEST_URL,
            RequestType.LIST_WIDGET,
            scroll
        );

        if(showFilter == true) {
            this.renderFilter();
        }
    }


    protected static onDocumentLoaded() {
        const jobLists = document.getElementsByClassName("jobcList");

        for(let i = 0; i < jobLists.length; ++i) {
			const jobList = jobLists[i];
			const instance = new JobListWidget(jobList as HTMLElement, i.toString());
        }
    }

    public responseCallback(res: IResponse): boolean {
        if (res.requestError) {
            this.jobListWidgetRenderer.renderError()
            return false
        }

        var response = <IResponseWithData<Array<JobOfferEntryDto>>>res;
        var responseDto = response.data as Array<JobOfferEntryDto>;
        //check if new data was available
        if (responseDto.length == 0) {
            return false;
        }
        this.requestDto.pageNumber = this.requestDto.pageNumber + 1;
        //Render JobOffers Items
        this.scrollHelper.setRequestDto(this.requestDto);
        for (var i = 0; i < responseDto.length; i++) {
            this.jobListWidgetRenderer.renderJobOffer(responseDto[i]);
            if ((this.listItemCount + i + 1) >= this.requestDto.maxItems) {
                //do not display remaining items if total count would be larger than max item count
                return false;
            }
        }
        this.listItemCount = this.listItemCount + responseDto.length;
        return true;
    }

    private renderFilter() {
        var filterContainer = document.createElement('div');
        filterContainer.classList.add('filterContainer');
        var filterTitle = document.createElement('p');
        filterTitle.classList.add('filterTitle');
        filterTitle.innerText = 'Filter:';
        filterContainer.appendChild(filterTitle);

        
        this.checkboxFilterFullTime = document.createElement('input');
        var checkboxFilterFullTimeID = "checkboxFilterFullTime" + this.id;
        this.checkboxFilterFullTime.type = "checkbox";
        this.checkboxFilterFullTime.name = checkboxFilterFullTimeID;
        this.checkboxFilterFullTime.id = checkboxFilterFullTimeID;
        var labelCheckboxFilterFullTime = document.createElement('label');
        labelCheckboxFilterFullTime.htmlFor = checkboxFilterFullTimeID;
        labelCheckboxFilterFullTime.appendChild(document.createTextNode('Vollzeit'));

        this.checkboxFilterPartTime = document.createElement('input');
        var checkboxFilterPartTimeID = "checkboxFilterPartTime" + this.id;
        this.checkboxFilterPartTime.type = "checkbox";
        this.checkboxFilterPartTime.name = checkboxFilterPartTimeID;
        this.checkboxFilterPartTime.id = checkboxFilterPartTimeID;
        var labelCheckboxFilterPartTime = document.createElement('label');
        labelCheckboxFilterPartTime.htmlFor = checkboxFilterPartTimeID;
        labelCheckboxFilterPartTime.appendChild(document.createTextNode('Teilzeit'));

        this.checkboxFilterApprentice = document.createElement('input');
        var checkboxFilterApprenticeID = "checkboxFilterApprentice" + this.id;
        this.checkboxFilterApprentice.type = "checkbox";
        this.checkboxFilterApprentice.name = checkboxFilterApprenticeID;
        this.checkboxFilterApprentice.id = checkboxFilterApprenticeID;
        var labelCheckboxFilterApprentice = document.createElement('label');
        labelCheckboxFilterApprentice.htmlFor = checkboxFilterApprenticeID;
        labelCheckboxFilterApprentice.appendChild(document.createTextNode('Ausbildung/Lehrstelle'));

        switch (this.requestDto.employmentTypeFilter) {
            case 1:
                this.checkboxFilterFullTime.checked = true;
                break;
            case 2:
                this.checkboxFilterPartTime.checked = true;
                break;
            case 4:
                this.checkboxFilterApprentice.checked = true;
                break;
            default:
                break;
        }
        this.checkboxFilterFullTime.addEventListener('click', (ev: Event) => { this.handleFilterSelection(ev, this)});
        this.checkboxFilterPartTime.addEventListener('click', (ev: Event) => { this.handleFilterSelection(ev, this)});
        this.checkboxFilterApprentice.addEventListener('click', (ev: Event) => { this.handleFilterSelection(ev, this)});
        
        filterContainer.appendChild(this.checkboxFilterFullTime);
        filterContainer.appendChild(labelCheckboxFilterFullTime);

        
        filterContainer.appendChild(this.checkboxFilterPartTime);
        filterContainer.appendChild(labelCheckboxFilterPartTime);

        filterContainer.appendChild(this.checkboxFilterApprentice);
        filterContainer.appendChild(labelCheckboxFilterApprentice);

        this.target.insertBefore(filterContainer, this.target.firstChild);
    }

    private handleFilterSelection(ev: Event, jobListWidget: JobListWidget){
        const clickedCheckbox = ev.target as HTMLInputElement;
        const clickedCheckboxState = clickedCheckbox.checked;
        const allCheckboxes = clickedCheckbox.parentElement.getElementsByTagName('input');
        for(let i = 0; i < allCheckboxes.length; ++i) {
            const checkbox = allCheckboxes[i] as HTMLInputElement;
            checkbox.checked = false;
        }
        clickedCheckbox.checked = clickedCheckboxState;
        if(clickedCheckbox.id == jobListWidget.checkboxFilterFullTime.id && clickedCheckbox.checked == true) {
            jobListWidget.requestDto.employmentTypeFilter = 1;
        } else if (clickedCheckbox.id == jobListWidget.checkboxFilterPartTime.id && clickedCheckbox.checked == true) {
            jobListWidget.requestDto.employmentTypeFilter = 2;
        } else if (clickedCheckbox.id == jobListWidget.checkboxFilterApprentice.id && clickedCheckbox.checked == true) {
            jobListWidget.requestDto.employmentTypeFilter = 4;
        } else {
            jobListWidget.requestDto.employmentTypeFilter = 0;
        }
        jobListWidget.requestDto.pageNumber = 0;
        jobListWidget.listItemCount = 0;
        jobListWidget.scrollHelper.reInit(jobListWidget.requestDto);
    }



}